module.exports = __webpack_public_path__ + "nc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/nc.svg
// module id = 724
// module chunks = 0